module.exports = __webpack_public_path__ + "img/consumo.fb9580d8.jpg";